
































































































import {Vue, Component, Prop, Watch} from 'vue-property-decorator';
import FormData from "@/modules/budget/monitoring/input-forms/components/application41/FormData.vue";
import {
    findDeviationIssues,
    hasImplPeriodDeviation,
    hasFinancingDeviation,
    hasTargetIndicatorsDeviation,
} from "@/modules/budget/monitoring/input-forms/components/application41/deviationValidation";
import axios from "axios";

@Component({
    components: {
        'form-data': FormData,
    },
})
export default class application_41 extends Vue {
    @Prop({
        required: false,
        default: ''
    })
    private user_id!:any;
    @Prop({
        required: false,
        default: 1000, // Set the desired default here
    })
    private convert!:any;
    @Prop({
        required: true,
        default: null
    })
    private currForm!:any;
    @Prop({
        required: true,
        default: null
    })
    private reportFormView!:any;
    @Prop({
        required: true,
        default: null
    })
    private editAccess!:any;
    @Prop({
        required: true,
        default: null
    })
    private deleteAccess!:any;
    @Prop({
        required: true,
        default: []
    })
    private childStatus!:any;

    private gipFormOpen: boolean = false;
    private gipForm: any = null;
    // Сниомок карточки на момент открытия (NTF.eAk.APPL41.04) — сравнивается с текущим
    // состоянием gipForm при попытке закрыть карточку, чтобы понять, есть ли несохранённые
    // изменения. gipForm — та же ссылка, что и строка в dataList (мутируется дочерними
    // компонентами напрямую), пэтому снимок делается глубокой сериализацией.
    private gipFormSnapshot: string | null = null;
    // NTF.eAk.APPL41.01 — после неудачной попытки сохранения включает подсветку полей
    // причины отклонения на активной и неактивной вкладках карточки (см. FormData.vue).
    private validationActive: boolean = false;

    private dataList: any[] = []
    // Расхождения между живым списком ГИП (Скорр.план) и Application41BipForms —
    // из ответа /gip-forms (state_info). Заполняются только когда форма открывается
    // НЕ первый раз (при первом открытии всё создаётся сразу, расхождений нет).
    private stateInfo: any = { new_expense_codes: [], deleted_expense_codes: [] }

    private get hasListDiscrepancies(): boolean {
        return (this.stateInfo.new_expense_codes || []).length > 0 || (this.stateInfo.deleted_expense_codes || []).length > 0
    }
    private loading: boolean = false;
    private tr_path: string = 'modules.budget_execution_monitoring.reports.app41.'

    // Справочник "Предназначение инвестиций" (dict_purpose_of_investments), элементы вида
    // {id, code, name_ru, name_kk}. Передаётся вниз в form-data -> genView как prop.
    private investOptions: any[] = [];

    private tableFields:any[] = [
        {
            label: '№',
            key: 'number'
        },
        {
            label: 'КОД',
            key: 'expense_code'
        },
        {
            label: 'Наименование проекта',
            key: 'project_name'
        },
        {
            label: 'АБП/БП',
            key: 'abp_prg'
        },
        {
            label: 'Период реальзации',
            key: 'impl_period'
        },
        {
            label: 'КОД БИП',
            key: 'bip_code'
        },
        {
            label: '',
            key: 'more'
        }
    ]

    private async created() {
        this.$emit('onRegisterFacade', this)
        await this.getInvestOptions();
        await this.loadGipForms();
    }

    // NTF.eAk.APPL41.02 — ошибка получения данных из внешнего источника при открытии
    // карточки/списка ГИП: сообщение с автозакрытием (toast), список не обновляется
    // (транзакция загрузки не применяется — dataList остаётся как есть).
    // is_update=true — нажатие ссылки "Обновите список ГИП" в красной строке
    // (state-banner): синхронизирует Application41BipForms с живым списком (создаёт
    // появившиеся ГИП, удаляет пропавшие). Без этого флага (обычное открытие/
    // перезагрузка) список лишь показывает уже зафиксированное + расхождения в stateInfo.
    private async loadGipForms(is_update: boolean = false) {
        this.loading = true;
        try {
            const resp = await axios.post('/api-py/application/input-forms/41/gip-forms', {
                currForm: this.currForm,
                user_id: this.user_id,
                is_update,
            });
            this.dataList = resp.data.dataList;
            // Список ГИП — по коду ГИП (RQ, решение владельца продукта). Бэк уже
            // отдаёт data_list отсортированным (get_gip_forms, input_form_41.py) —
            // сортировка тут защитная, на случай локальных правок dataList на фронте.
            this.dataList.sort((a: any, b: any) => String(a.expense_code || '').localeCompare(String(b.expense_code || '')));
            // Каждый ГИП получает свои поля-валидаторы (flk_impl_period_deviation/
            // flk_financing_deviation/flk_target_indicators_deviation) и итоговый flk —
            // см. assignFlkProperties. dataList приходит с сервера заново на каждую
            // загрузку (новые объекты), поэтому переопределение свойств безопасно.
            this.dataList.forEach((item: any) => this.assignFlkProperties(item));
            this.stateInfo = resp.data.state_info || { new_expense_codes: [], deleted_expense_codes: [] };
            // Флк формы app41 (currForm) пересчитывается после каждой загрузки списка
            // ГИП — покрывает и первое открытие формы, и обновление по кнопке
            // "Обновите список ГИП".
            await this.updateParentFormFlk();
        } catch (error) {
            this.makeToast(
                'danger',
                this.$t(`${this.tr_path}notifications.fetch_error_title`),
                this.$t(`${this.tr_path}notifications.fetch_error_message`)
            );
        } finally {
            this.loading = false;
        }
    }

    // Флк формы app41 (currForm) — своего согласования у ГИП больше нет (см. докстринг
    // Application41BipForms в input_form_41.py), поэтому флк родителя — это просто
    // агрегат живых флк всех ГИП: true ("есть проблема"), если хотя бы у одного ГИП
    // flk === true, иначе false. Пересчитывается при каждой загрузке списка ГИП
    // (loadGipForms) и сразу после сохранения карточки одного ГИП (saveData).
    private async updateParentFormFlk() {
        if (!this.currForm || !this.currForm.id) {
            return
        }
        const hasProblems = this.dataList.some((row: any) => row.flk)
        await axios.post('/api-py/input-forms/flk', {
            flk: hasProblems,
            form_id: this.currForm.id
        }).catch(e => {})
    }

    // Валидаторы флк отдельного ГИП — каждый принимает item (строку dataList) и
    // возвращает true, если по этой категории есть отклонение план/факт без указанной
    // причины (та же проверка, что блокирует "Сохранить" — см. deviationValidation.ts).
    // Вызываются не напрямую, а через геттеры, навешенные в assignFlkProperties.
    private flk_impl_period_deviation(item: any): boolean {
        return hasImplPeriodDeviation(item)
    }

    private flk_financing_deviation(item: any): boolean {
        return hasFinancingDeviation(item)
    }

    private flk_target_indicators_deviation(item: any): boolean {
        return hasTargetIndicatorsDeviation(item)
    }

    // Навешивает на ГИП (item = строка dataList) по одному геттеру на каждый валидатор
    // флк + итоговый item.flk (true, если сработал хотя бы один). Геттеры живые —
    // читают item на момент обращения, а не считают один раз при загрузке, поэтому
    // остаются верными и после правок в открытой карточке (genView/targetIndicators
    // мутируют тот же объект, что лежит в dataList, см. openGIPForm).
    private assignFlkProperties(item: any) {
        const that = this;
        Object.defineProperties(item, {
            'flk_impl_period_deviation': {
                get: function() {
                    return that.flk_impl_period_deviation(item)
                },
                configurable: true
            },
            'flk_financing_deviation': {
                get: function() {
                    return that.flk_financing_deviation(item)
                },
                configurable: true
            },
            'flk_target_indicators_deviation': {
                get: function() {
                    return that.flk_target_indicators_deviation(item)
                },
                configurable: true
            },
            'flk': {
                get: function() {
                    return item.flk_impl_period_deviation || item.flk_financing_deviation || item.flk_target_indicators_deviation
                },
                configurable: true
            }
        })
    }

    private async getInvestOptions() {
        await axios.get('/api-py/application/input-forms/41/purpose-of-investments').then(resp => {
            this.investOptions = resp.data;
        })
    }

    // Удаление строки ГИП из списка ("⋮" -> "Удалить") — своей формы согласования у
    // ГИП больше нет, поэтому запрос идёт прямо на Application41BipForms.id (row.id),
    // без проверки статуса согласования (её больше нет на уровне ГИП).
    private async deleteForm(row: any) {
        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.confirm_form_deletion').toString(),
            {
                title: this.$t('modules.budget_execution_monitoring.reports.app_9.confirmation').toString(),
                buttonSize: 'sm',
                okVariant: 'success',
                okTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.yes').toString(),
                cancelTitle: this.$t('modules.budget_execution_monitoring.input_forms.massage_tools.cancellation').toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        )

        if (!confirmed) {
            return
        }

        try {
            this.loading = true
            await axios.post('/api-py/application/input-forms/41/gip-forms/delete', { id: row.id })
            this.dataList = this.dataList.filter(v => v.id !== row.id)
        } catch (error) {
            console.error(error)
        } finally {
            this.loading = false
        }
    }

    // gipForm теперь синхронизируется из FormData (.sync) — переключение ГИП внутри
    // открытой карточки (‹далее›/дропдаун) тоже меняет this.gipForm, а не только
    // openGIPForm(). Снимок (NTF.eAk.APPL41.04) и подсветку (NTF.eAk.APPL41.01) в этом
    // случае нужно сбросить под НОВЫЙ ГИП — иначе "несохранённые изменения" будут
    // ложно считаться по разнице между разными ГИП, а не по факту правок.
    @Watch('gipForm')
    private onGipFormChanged(newVal: any, oldVal: any) {
        if (newVal && oldVal && newVal.expense_code !== oldVal.expense_code) {
            this.gipFormSnapshot = JSON.stringify(newVal)
            this.validationActive = false
        }
    }

    private openGIPForm(gipForm: any) {
        this.gipForm = gipForm;
        this.gipFormSnapshot = JSON.stringify(gipForm);
        this.validationActive = false;
        this.gipFormOpen = true;
    }

    // NTF.eAk.APPL41.04 — нажатие "Закрыть" при наличии несохранённых изменений или
    // отклонений без указанной причины: подтверждение "Остаться"/"Выйти".
    private async onBack() {
        if (this.gipFormOpen) {
            const canClose = await this.confirmCloseGipForm()
            if (canClose) {
                this.rollbackGipForm()
                this.gipFormOpen = false
                this.gipForm = null
                this.gipFormSnapshot = null
                this.validationActive = false
            }
            return false;
        }
        return true
    }

    // Выход из карточки без сохранения — несохранённые правки откатываются к снимку,
    // сделанному при открытии (gipFormSnapshot) или при последнем успешном сохранении.
    // gipForm — та же ссылка, что строка в dataList (с живыми флк-геттерами, они
    // неперечисляемые и в снимок не попадают), поэтому объект восстанавливается на месте,
    // а не заменяется новым.
    private rollbackGipForm() {
        if (!this.gipForm || this.gipFormSnapshot === null) {
            return
        }
        const saved = JSON.parse(this.gipFormSnapshot)
        Object.keys(this.gipForm).forEach((key: string) => {
            if (!(key in saved)) {
                this.$delete(this.gipForm, key)
            }
        })
        Object.keys(saved).forEach((key: string) => {
            this.$set(this.gipForm, key, saved[key])
        })
    }

    private async confirmCloseGipForm(): Promise<boolean> {
        const isDirty = this.gipFormSnapshot !== null && JSON.stringify(this.gipForm) !== this.gipFormSnapshot
        const hasDeviationIssues = findDeviationIssues(this.gipForm).length > 0
        if (!isDirty && !hasDeviationIssues) {
            return true
        }
        const confirmed = await this.$bvModal.msgBoxConfirm(
            this.$t(`${this.tr_path}notifications.unsaved_changes_message`).toString(),
            {
                title: this.$t(`${this.tr_path}notifications.unsaved_changes_title`).toString(),
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: this.$t(`${this.tr_path}notifications.exit`).toString(),
                cancelTitle: this.$t(`${this.tr_path}notifications.stay`).toString(),
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            }
        )
        return !!confirmed
    }

    // Дёргается из BEIFOpenWindow.vue (facade.saveData()) по кнопке "Сохранить".
    // Сохраняет карточку текущей открытой ГИП-формы (this.gipForm) —
    // пока только invest_options, остальные поля карточки добавятся следующими шагами.
    // NTF.eAk.APPL41.01 — попытка сохранения при наличии показателей с отклонением ≠ 0
    // без указанной причины: сохранение блокируется, показывается модальное окно, активная
    // вкладка переключается на первое найденное нарушение, поля причины подсвечиваются
    // (см. genView.vue/targetIndicators.vue, validationActive).
    private async saveData() {
        if (!this.gipFormOpen || !this.gipForm || !this.gipForm.id) {
            return
        }
        const issues = findDeviationIssues(this.gipForm)
        if (issues.length > 0) {
            this.validationActive = true
            // eslint-disable-next-line
            // @ts-ignore
            this.$refs.gip_data.focusTab(issues[0].tab)
            await this.$bvModal.msgBoxOk(
                this.$t(`${this.tr_path}notifications.save_blocked_message`).toString(),
                {
                    title: this.$t(`${this.tr_path}notifications.save_blocked_title`).toString(),
                    okVariant: 'danger',
                    buttonSize: 'sm',
                    centered: true
                }
            )
            return
        }
        // NTF.eAk.APPL41.03 — успешное сохранение дополнительных данных по ГИП.
        await axios.post('/api-py/application/input-forms/41/gip-forms/save', this.gipForm).then(resp => {
            this.validationActive = false
            this.gipFormSnapshot = JSON.stringify(this.gipForm)
            this.makeToast(
                'success',
                this.$t(`${this.tr_path}notifications.save_success_title`),
                this.$t(`${this.tr_path}notifications.save_success_message`)
            )
            // Правки в карточке ГИП меняют его живой флк (assignFlkProperties) —
            // пересчитываем агрегат сразу, не дожидаясь следующей полной загрузки списка.
            this.updateParentFormFlk()
        })
    }


    // RQ.eAk.APPL41.50 — кнопка "Скачать" на списке ГИП: выгрузка по шаблону
    // 41-ОХРБИПБИПУГУКЮЛ (графы 1-41). downloadList — общий для всех форм ввода
    // список действий, который читает b-dropdown в BEIFOpenWindow.vue (facade.downloadList).
    private get downloadList() {
        const reportList: any[] = []
        if (this.currForm.form_code === 'app41') {
            reportList.push({
                fn: this.downloadRep,
                args: [],
                name: this.$t(`${this.tr_path}download_item`),
                idx: reportList.length
            })
        }
        return reportList
    }

    // Скачивание отчёта (RQ.eAk.APPL41.50) — эндпоинт /api-py/application/input-forms/41/report
    // сам вызывает get_gip_forms и строит xlsx по шаблону 41-ОХРБИПБИПУГУКЮЛ. Локаль — текущая
    // локаль интерфейса ($i18n.locale), отдельного выбора RU/KK на кнопке нет.
    private async downloadRep() {
        const locale = this.$i18n.locale
        try {
            const resp = await axios.post(
                '/api-py/application/input-forms/41/report',
                { currForm: this.currForm, locale, user_id: this.user_id },
                { responseType: 'blob' }
            )
            const url = URL.createObjectURL(new Blob([resp.data]))
            const a = document.createElement('a')
            a.href = url
            const currentDate = new Date().toLocaleDateString('ru-RU')
            a.download = `${this.$t(`${this.tr_path}download_item`)} - ${this.currForm.abp} АБП - ${currentDate}.xlsx`
            a.click()
            URL.revokeObjectURL(url)
        } catch (e) {
            this.makeToast(
                'danger',
                this.$t(`${this.tr_path}notifications.fetch_error_title`),
                this.$t(`${this.tr_path}notifications.fetch_error_message`)
            )
        }
    }

    private makeToast(variant: any, title: any, tostbody: any) {
        this.$bvToast.toast(tostbody, {
            title: title,
            variant: variant,
            toaster: 'b-toaster-top-center',
            autoHideDelay: 5000,
            appendToast: true
        });
    }
}
